{
	"type": "fill",
	"minzoom": 8,
	"layout": {},
	"paint": {
		"fill-color": [
			"match",
			["concat", ["to-string", ["get", "sym_code"]], "|", ["get", "lay_class"]],
			["2(a)|Residential (Low Density)", "R2|Low Density Residential"],
			"#ffa6a3",
			"2(c)|Urban Expansion",
			"#ffbee8",
			"7(a)|Environmental Protection (Wetlands and Littoral Rainforests)",
			"#ffd37f",
			"7(l)|Environmental Protection (Habitat)",
			"#ffaa00",
			"A|Residential Zone - Medium Density Residential",
			"#fc776e",
			"AGB|Agribusiness",
			"#fae8c5",
			"B|Business Zone - Local Centre",
			"#63f0f5",
			"B1|Neighbourhood Centre",
			"#c9fff9",
			"B2|Local Centre",
			"#62f0f5",
			["B3|Commercial Core", "E|Business Zone - Commercial Core"],
			"#00c2ed",
			[
				"B4|Mixed Use",
				"D|Business Zone - Mixed Use",
				"MU|Mixed Use",
				"MU1|Mixed Use",
				"REPL|Public Recreation – Preferred Locations"
			],
			"#959dc2",
			"B5|Business Development",
			"#7da0ab",
			["B6|Enterprise Corridor", "EM|Employment"],
			"#95bfcc",
			["B7|Business Park", "C|Business Zone - Business Park"],
			"#bad6de",
			"C1|National Parks and Nature Reserves",
			"#e69900",
			["C2|Environmental Conservation", "E|Environment", "E2|Environmental Conservation"],
			"#f0ae3c",
			"C3|Environmental Management",
			"#f7c568",
			"C4|Environmental Living",
			"#ffda96",
			["DM|Deferred Matter", "UL|Unzoned Land"],
			"#ffffff",
			["DR|Drainage", "G|Special Purposes Zone - Infrastructure", "SP2|Infrastructure"],
			"#ffff70",
			"E1|Local Centre",
			"#99ccff",
			"E2|Commercial Centre",
			"#b4c6e7",
			"E3|Productivity Support",
			"#8ea9db",
			"E4|Environmental Living",
			"#8790e0",
			"E4|General Industrial",
			"#9999ff",
			"E5|Heavy Industrial",
			"#9966ff",
			"ECO|Environmental Conservation",
			"#ecffbe",
			"ENP|Environment Protection",
			"#ffd640",
			"ENT|Enterprise",
			"#76c0d6",
			"ENZ|Environment and Recreation",
			"#73b273",
			"EP|Employment",
			"#fcf9b6",
			"F|Special Purposes Zone - Comminity",
			"#ffffa1",
			["H|Recreation Zone - Public Recreation", "RE1|Public Recreation", "RO|Regional Open Space"],
			"#55ff00",
			"I|Recreation Zone - Private Recreation",
			"#d3ffbf",
			["IN1|General Industrial", "REZ|Regional Enterprise Zone"],
			"#deb8f5",
			"IN2|Light Industrial",
			"#f3dbff",
			"IN3|Heavy Industrial",
			"#c595e8",
			"MAP|Marine Park",
			"#e6ffff",
			"OSP|Open Space",
			"#596ecc",
			"P|Parkland",
			"#b3ccfc",
			"PAE|Port and Employment",
			"#f4ec49",
			"PEP|Permanent Park Preserve",
			"#74b374",
			"PRC|Public Recreation",
			"#549980",
			"PRR|Public Recreation - Regional",
			"#70a600",
			"R|Residential",
			"#b3fcb3",
			"R1|General Residential",
			"#ffcfff",
			["R3|Medium Density Residential", "UR|Urban"],
			"#ff776e",
			"R4|High Density Residential",
			"#ff483b",
			"R5|Large Lot Residential",
			"#ffd9d9",
			["RAC|Rural Activity Zone", "RAZ|Rural Activity Zone", "RU2|Rural Landscape"],
			"#e6cb97",
			["RE2|Private Recreation", "RP|Regional Park"],
			"#d3ffbe",
			"REC|Recreation",
			"#aef2b3",
			"RESB|Residential – Business",
			"#3456b8",
			"RESI|Residential",
			"#3254b7",
			"RLWY|Railways",
			"#2e52b5",
			"RU1|Primary Production",
			"#edd8ad",
			"RU3|Forestry",
			"#dec083",
			"RU4|Primary Production Small Lots",
			"#d6b46f",
			"RU5|Village",
			"#d7a39e",
			"RU6|Transition",
			"#c79e4c",
			"RUR|Rural",
			"#efe4be",
			"RW|Road and Road Widening",
			"#d3b8f5",
			"SET|Settlement",
			"#ffd2dc",
			"SP1|Special Activities",
			"#ffffa0",
			["SP3|Tourist", "SP4|Enterprise", "SPU|Special Uses"],
			"#ffff00",
			"SP5|Metropolitan Centre",
			"#e6e600",
			"SUS|Special Uses",
			"#1141a1",
			"T|Tourism",
			"#fcd2ef",
			"U|Unzoned",
			"#cafced",
			"UD|Urban Development",
			"#ff7f63",
			"W|Waterway",
			"#fcc4b8",
			"W1|Natural Waterways",
			"#d9fff2",
			"W2|Recreational Waterways",
			"#99ffdd",
			"W3|Working Waterways",
			"#33ffbb",
			"W4|Working Waterfront",
			"#00e6a9",
			"WFU|Waterfront Use",
			"#1182c2",
			"rgba(0,0,0,0)"
		]
	}
}
